module.exports = __webpack_public_path__ + "static/media/thrid-house.0dbaed4b.jpg";